export default () => {
  const { LiveChatWidget } = window;

  if (LiveChatWidget) {
    LiveChatWidget.call('maximize');
  }
};
